import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import BOCompteSocieteTabMarques from "../../../components/BOCompteSocieteTabMarques";
import BOCompteSocieteTabActeursJuridiques from "../../../components/BOCompteSocieteTabActeursJuridiques";
import BOCompteSocieteTabFond from "../../../components/BOCompteSocieteTabFond";

interface InscriptionFormMarquesProps {
  isOpen: boolean;
  isUpdating: boolean;
  typeCompte?: number;
  IdSociete?: number;
  IdEtatDemandeInscription?: number;
  onToggle: () => void;
  onAnnuler?: () => void;
  onValider?: (typeCompte?: number) => void;
  onRefuser?: () => void;
  onDesactiver?: () => void;
}

const InscriptionFormMarques: React.FC<InscriptionFormMarquesProps> = ({
  isOpen,
  isUpdating,
  typeCompte,
  IdSociete,
  IdEtatDemandeInscription,
  onToggle,
  onAnnuler,
  onValider,
  onRefuser,
  onDesactiver
}) => {
  const [currTabName, setcurrTabName] = useState("marques");
  
  // Vérifier si on doit afficher le bouton "Désactiver le compte"
  const showDesactiverButton = IdEtatDemandeInscription === 2 && typeCompte !== 4;
  
  // Mode validé : afficher seulement le fonds total et le bouton désactiver
  const isModeValide = IdEtatDemandeInscription === 2;
  
  return (
    <div className="card mb-3 shadow-sm">
      <div 
        className="card-header d-flex justify-content-between align-items-center" 
        style={{ 
          cursor: "pointer",
          background: "linear-gradient(135deg, #4a6fa5 0%, #5681bb 100%)",
          color: "white",
          padding: "1rem 1.5rem",
          borderRadius: "0.375rem 0.375rem 0 0"
        }}
        onClick={onToggle}
      >
        <h5 className="mb-0 fw-semibold">
          <i className="bi bi-bookmark-star me-2"></i>
          {isModeValide ? "Fonds total affectés" : "Affectation des marques"}
        </h5>
        <i className={`bi bi-chevron-${isOpen ? "up" : "down"} fs-5`}></i>
      </div>
      <div style={{ display: isOpen ? "block" : "none" }}>
        <div className="card-body">
          {IdSociete !== null && IdSociete !== undefined && IdSociete >= 0 ? (
            <>
              {isModeValide ? (
                // Mode validé : afficher seulement le fonds total
                <BOCompteSocieteTabFond 
                  IdSociete={IdSociete} 
                  refetch={isOpen}
                />
              ) : (
                // Mode normal : afficher tous les onglets
                <Tabs 
                  defaultActiveKey={currTabName} 
                  id="affectation-tabs" 
                  onSelect={(key) => setcurrTabName(key ?? "marques")} 
                  className="onglet mb-3"
                >
                  <Tab eventKey="marques" title="Affectation des marques">
                    <BOCompteSocieteTabMarques 
                      IdSociete={IdSociete} 
                      refetch={currTabName === "marques"}
                    />
                  </Tab>
                  <Tab eventKey="acteursjuridiques" title="Affectation des acteurs juridiques">
                    <BOCompteSocieteTabActeursJuridiques 
                      IdSociete={IdSociete} 
                      refetch={currTabName === "acteursjuridiques"}
                    />
                  </Tab>
                  <Tab eventKey="fondtotal" title="Fonds total affectés">
                    <BOCompteSocieteTabFond 
                      IdSociete={IdSociete} 
                      refetch={currTabName === "fondtotal"}
                    />
                  </Tab>
                </Tabs>
              )}
              
              <div className="mt-4 pt-3 border-top">
                {isModeValide ? (
                  // Mode validé : afficher seulement le bouton désactiver
                  showDesactiverButton && (
                    <div className="row g-3">
                      <div className="col-12">
                        <button
                          type="button"
                          className="btn btn-warning w-100"
                          onClick={onDesactiver}
                          disabled={isUpdating}
                          style={{ padding: "12px" }}
                        >
                          <i className="bi bi-dash-circle-fill me-2"></i>
                          {isUpdating ? "Traitement..." : "Désactiver le compte"}
                        </button>
                      </div>
                    </div>
                  )
                ) : (
                  // Mode affectation des marques : afficher seulement le bouton activer
                  <div className="row g-3">
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={() => onValider?.(Number(typeCompte))}
                        disabled={isUpdating}
                        style={{ padding: "12px" }}
                      >
                        {isUpdating ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Traitement...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-check-circle-fill me-2"></i>
                            Activer le compte
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="alert alert-warning">
              Le compte société doit être créé avant d&apos;affecter les marques.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InscriptionFormMarques;
